import { USER_LOGOUT } from "../constants/miscConstants.js";

export const userLogout = user => ({
  type: USER_LOGOUT,
  payload: user
});
